"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const client_1 = require("@apollo/client");
const mutation = (0, client_1.gql) `
  mutation updateUserEmail ($newEmail: String!) {
    updateUserEmail (newEmail: $newEmail) {
      _id
      firstName
      lastName
      email
      emailVerifiedAt
      phoneNumber
      phoneNumberVerifiedAt
      orgContextId
      phoneNumberWaitingForVerify
      emailWaitingForVerify
      userProfile {
        imageUrl
      }
    }
  }
`;
exports.default = mutation;
//# sourceMappingURL=updateUserEmail.mutation.js.map